import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col, Card } from "react-bootstrap";
import PageLayout from "../../layouts/PageLayout";
import { useNavigate } from "react-router-dom";

export default function DashboardPage() {
    const { t } = useContext(TranslatorContext);
    const navigate = useNavigate();
    const [currentTime, setCurrentTime] = useState(new Date());
    
    // Get user info from localStorage
    const userName = localStorage.getItem('name') || 'User';
    const userRole = localStorage.getItem('role') || 'Admin';
    const userEmail = localStorage.getItem('email') || '';

    // Update time every minute
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 60000);

        return () => clearInterval(timer);
    }, []);

    // Get time-based greeting
    const getGreeting = () => {
        const hour = currentTime.getHours();
        if (hour < 12) {
            return t('good_morning') || 'Good Morning';
        } else if (hour < 17) {
            return t('good_afternoon') || 'Good Afternoon';
        } else {
            return t('good_evening') || 'Good Evening';
        }
    };



    return (
        <PageLayout>
            <Row>
                {/* Welcome Section */}
                <Col xl={12}>
                    <div className="mc-card">
                        <div className="welcome-section" style={{ 
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            color: 'white',
                            padding: '40px 30px',
                            borderRadius: '10px',
                            marginBottom: '20px'
                        }}>
                            <Row className="align-items-center">
                                <Col lg={8}>
                                    <h2 style={{ 
                                        fontSize: '2.5rem', 
                                        fontWeight: 'bold', 
                                        marginBottom: '10px',
                                        textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                    }}>
                                        {getGreeting()}, {userName}! 👋
                                    </h2>
                                    <div style={{ 
                                        display: 'flex', 
                                        gap: '20px', 
                                        fontSize: '0.9rem',
                                        opacity: 0.8
                                    }}>
                                        <span>
                                            <i className="material-icons" style={{ fontSize: '16px', verticalAlign: 'middle', marginRight: '5px' }}>
                                                person
                                            </i>
                                            {userRole}
                                        </span>
                                        <span>
                                            <i className="material-icons" style={{ fontSize: '16px', verticalAlign: 'middle', marginRight: '5px' }}>
                                                email
                                            </i>
                                            {userEmail}
                                        </span>
                                        <span>
                                            <i className="material-icons" style={{ fontSize: '16px', verticalAlign: 'middle', marginRight: '5px' }}>
                                                schedule
                                            </i>
                                            {currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                        </span>
                                    </div>
                                </Col>
                                <Col lg={4} className="text-center">
                                    <div style={{ 
                                        fontSize: '4rem',
                                        opacity: 0.3
                                    }}>
                                        <i className="material-icons" style={{ fontSize: 'inherit' }}>
                                            dashboard
                                        </i>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>


            </Row>
        </PageLayout>
    );
}